import { motion } from "framer-motion"
import { BannerStyle } from "../_config";
import { cn } from "~/lib/utils";
import { usePlan } from "../plan.context";
import { object } from "zod";

interface BannerProps {
  url: string;
  alt: string;
}

export default function Banner({ url, alt }: BannerProps) {
  const { color } = usePlan()

  return (
    <motion.div
      viewport={{ once: true }}
      initial={{ opacity: 0, x: 40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="z-20 relative w-full md:w-1/2"
    >

      <div className={cn("bg-gradient absolute -inset-4 rounded-3xl bg-linear-to-tr opacity-20 blur-3xl overflow-hidden", BannerStyle[color])}></div>
      {
        url.endsWith(".svg")
        ? (
          <object data={url} type="image/svg+xml" className="relative w-full rounded-4xl drop-shadow-xl aspect-video object-cover"/>
        )
        : (
          <img
            src={url}
            alt={alt}
            className="relative w-full rounded-4xl drop-shadow-xl aspect-video object-cover"
          />
        )
      }
    </motion.div>
  );
}
